namespace JupitersChoice {
    export class ShowFreeGameCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        static currentFreeGameSpinIdx;

        execute(): void {
            ShowFreeGameCmd.currentFreeGameSpinIdx = 0;
            this._componentManager.get('FreeGamePopup').setOrientation(this._orientationModel.getCurrentOrientation());
            this._componentManager.get('PaylineDisplay').setOrientation(this._orientationModel.getCurrentOrientation());
            this._componentManager.get('SkipPaylinesButton').setOrientation(this._orientationModel.getCurrentOrientation());

            // stop base game flames
            for (let i = 1; i < 3; i++) {
                this._componentManager.get(`BaseGameFlame${i}`).hide(); 
                this._componentManager.get(`BaseGameFlame${i}`).stop();
            }

            // start bonus game flames
            for (let i = 1; i < 9; i++) {
                this._componentManager.get(`FreeGameFlame${i}`).show();
                this._componentManager.get(`FreeGameFlame${i}`).play();
            }

            TweenMax.delayedCall(1, () => {
                this._eventManager.publish('onStartFreeGame');
            });
        }
    }
}